@if(incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if(loonTegenwoordigeArbeid.length > 0) {
      <div formArrayName="loonTegenwoordigeArbeid">
        @for (item of loonTegenwoordigeArbeid.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <div class="col-auto row" style="--bs-gutter-x: 0.5rem;" formGroupName="loon">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Werkgever' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving-' + i"
                                              snelstartUiBorderOnHover>
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Loon' : ''"
                                                [required]=true
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedrag-' + i"
                                                prefix="€">
              </snelstart-ui-number-form-control>
            </div>
            @if((incomeTaxEntity$ | async)?.taxType === "DA") {
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                @if((incomeTaxEntity$ | async)?.aangifte!.biljetSoort === "C") {
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [label]="i === 0 ? 'In NL onbelast deel' : ''"
                                                    align="right"
                                                    class="custom-input-150 "
                                                    formControlName="onbelastDeelLoonInNederland"
                                                    id="onbelastDeelLoonInNederland-' + i"
                                                    prefix="€">
                  </snelstart-ui-number-form-control>
                }

                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Loonheffing' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="custom-input-150 "
                                                  formControlName="loonheffing"
                                                  id="loonheffing-' + i"
                                                  prefix="€">
                </snelstart-ui-number-form-control>

                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Arbeidskorting' : ''"
                                                  [required]=true
                                                  align="right"
                                                  class="custom-input-150 "
                                                  formControlName="arbeidskorting"
                                                  id="arbeidskorting-' + i"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
              </div>
            }
            <div class="col-auto" >
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDelete-' + i"
                                   size="medium"
                                   type="secondary">
              </snelstart-ui-button>
            </div>
            @if (omschrijvingTeVeelKarakters(i)) {
              <div class="pb-2" style="width: 75%; color: red">
                Let op: het veld 'Werkgever' mag maximaal 70 karakters bevatten!
              </div>
            }
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()"
                       class="snelstart-ui-button"
                       icon="plus"
                       id="add"
                       type="link">
    Loon toevoegen
  </snelstart-ui-button>

  @if((incomeTaxEntity$ | async)?.aangifte!.biljetSoort !== "C" && heeftGeenOuderenkorting && loonTegenwoordigeArbeid.length > 0) {
    <form [formGroup]="wajongFg" (change)="saveForm()">
      <div class="row mb-1 pt-3">
        <div class="col-auto pt-4 pe-3">
          @if(isPartner) {
            <p>Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined}} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }} in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
              recht op de jonggehandicaptenkorting (wajong)?</p>
          } @else {
            <p>Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined}} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }} in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
              recht op de jonggehandicaptenkorting (wajong)?</p>
          }
        </div>

        <div class="col-auto">
          <snelstart-ui-select-form-control [options]="optionsJaNee"
                                            class="custom-input-225"
                                            formControlName="krijgtWajong"
                                            label="Selecteer"
          >
          </snelstart-ui-select-form-control>
        </div>
      </div>
    </form>
  }
}
